export default "__VITE_ASSET__JW1gfR8l__"